<template>
  <v-list aria-label="menu">
    <template v-for="(item, i) in menu" :key="i">
      <v-list-item
        v-if="(item.to || item.nick || item.href) && !item.children"
        :aria-label="item.label"
        role="option"
        :value="item"
        active-class="item-active"
        :active="!item.nick && (item?.to === route?.path || '/' + item?.to === route?.path)"
        v-bind="makeAttrs(item, $router)"
        v-on="makeClick(item, $router)"
      >
        {{ item.label }}
      </v-list-item>
    </template>
  </v-list>
</template>

<script setup>
const page = inject("page");

const props = defineProps({
  menu: { type: Array, required: false, default: () => [] },
});

const { makeAttrs, makeClick } = useLead(page);
const route = useRoute();
</script>
